export function getTaskListItemProps(value) {
  return {
    building: value.request?.building?.title,
    flat: value.request?.flat?.number,
    isArchived: value.archived,
    owner: {
      fullname: value.request?.owner?.fullname,
      role: value.request?.owner?.role,
    },
    request: value.request?.id,
    text: value.title,
    value: value.id,
  }
}
